import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { fromEvent } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ExternalLinkWatcherService {
    constructor(@Inject(DOCUMENT) private doc: Document) { }

    initExternalLinkWatcher() {
        return fromEvent<MouseEvent>(this.doc, 'click').pipe(
            filter((event) => {
                const target = event.target as HTMLElement;
                const anchor = target.closest('a');
                return !!anchor && anchor.getAttribute('target') === '_blank';
            })
        );
    }
}
